<template>
<div class='self-assessment_close-confirm'>
  <div
    v-if='trigger.icon'
    class='self-assessment_close-confirm_image'
  >
    <img
      :alt='trigger.title'
      :src='trigger.icon'
    >
  </div>

  <h2 class='self-assessment_close-confirm_title copy-one'>
    {{ trigger.title }}
  </h2>

  <div class='self-assessment_close-confirm_description copy-two'>
    {{ trigger.content }}
  </div>

  <button
    class='self-assessment_close-confirm_continue action-one'
    @click.prevent='continueAssessment'
  >
    {{ trigger.cta || $t('continue_assessment') }}
  </button>

  <button
    class='self-assessment_close-confirm_leave copy-three'
    @click.prevent='close'
  >
    {{ $t('leave_assessment') }}
  </button>
</div>
</template>

<script>
export default {
  props: [
    'toggle',
    'trigger'
  ],

  methods: {
    continueAssessment() {
      this.$parent.show_close_confirm = false
    },

    close() {
      this.toggle()
    }
  }
}
</script>

<style lang='sass' scoped>
  @import 'CloseConfirm'
</style>
